import { Component, inject, input } from '@angular/core';
import {ShippingInsertPrintOverlayComponent} from '../shipping-insert-print-overlay/shipping-insert-print-overlay.component';
import { MatDialog } from '@angular/material/dialog';
import { TreatmentModel } from 'libs/treatments/src/lib/models/treatment.model';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'lib-shipping-insert-print',
    templateUrl: './shipping-insert-print.component.html',
    styleUrls: ['./shipping-insert-print.component.scss'],
    imports: [MatButton, TranslatePipe]
})

export class ShippingInsertPrintComponent {
	dialog = inject(MatDialog);

	readonly treatment = input<TreatmentModel>(undefined);
	readonly customer = input<{
		displayName: string;
		wmsId: string;
	}>(undefined);

	openDialog() {
		const dialogData = { treatment: this.treatment(), customer: this.customer() };
		this.dialog.open(ShippingInsertPrintOverlayComponent,
			{ data: dialogData, maxWidth: '100vw', width: '100%', height: '100%' });
	}
}
